export const SIDE_EFFECT_COMMON = 'common';
export const SIDE_EFFECT_INDIVIDUAL = 'individual';
export const TOOLTIP_CONSOLIDATED = 'consolidated';
export const TOOLTIP_FRAGMENTED = 'fragmented';
export const WHEEL_DELTA_MODIFIER = 30;
